// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7646 ? "a3319169" : chunkId) + "." + {"4237":"ba9f810cfb44aabf","5516":"ff90afda3ae489fa","7646":"383ad9b580ac041a","9778":"51499251e138e969"}[chunkId] + ".js";
};